const { VUE_APP_API_HOST, NODE_ENV = "" } = process.env;

const environment = NODE_ENV.toLowerCase();

const coreBaseUrl = `${VUE_APP_API_HOST}/core/v0/resource`;
const thermBaseUrl = `${VUE_APP_API_HOST}/therm/v1/resource`;
const terraBaseUrl = `${VUE_APP_API_HOST}/terra/v1/resource`;
const jobsBaseUrl = `${VUE_APP_API_HOST}/jobs/v1/resource`;
const processingBaseUrl = `${VUE_APP_API_HOST}/processing/v1/resource`;

export {
  environment,
  thermBaseUrl,
  terraBaseUrl,
  coreBaseUrl,
  jobsBaseUrl,
  processingBaseUrl,
};
